import { render, staticRenderFns } from "./pengeluarankas.vue?vue&type=template&id=ab6768de&scoped=true"
import script from "./pengeluarankas.vue?vue&type=script&lang=js"
export * from "./pengeluarankas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6768de",
  null
  
)

export default component.exports